import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { LoaderService } from '../../../services/loader.service';
import { Observable } from 'rxjs/Rx';
import { CommunitymanagerService } from './communitymanager.service';
import { DesignerService } from '../../designer/designer.service';
import { Routes, RouterModule , Router,ActivatedRoute} from '@angular/router';
import { CategoryPipe } from '../../../shared/category.pipe';
import { SortPipe } from '../../../shared/sort.pipe';
import { NgPipesModule } from 'ngx-pipes';
import { SchedulerService } from '../../scheduler/scheduler.service';
import { Project, IGanttOptions, Zooming, Task } from '../../../shared/gantt-chart/interfaces';
declare var gantt : any;
declare var $:any;

@Component({
  selector: 'app-cm-dashboard',
  templateUrl: './cm-dashboard.component.html',
  styleUrls: ['./cm-dashboard.component.css'],
  providers: [CommunitymanagerService,SchedulerService,DesignerService]
})
export class CmDashboardComponent implements OnInit {


	CMId : string;
	errorMessage : string;
	erroralert = false;
	successalert = false;
	successMessage : string;
  errorMessagemodal : string;
  erroralertmodal = false;
  successalertmodal = false;
  successMessagemodal : string;
  usersCount:any;
  role;
  date_from:any = "";
  date_to:any = "";
  filter_designer:any = '';
  disable_to:any = true;
  my_designers:any = []

	constructor(
		private loaderService : LoaderService,
		private cmService : CommunitymanagerService,
    private formBuilder:FormBuilder
	) { 
		this.CMId = localStorage.getItem('userId');
	}

  ngOnInit() {
		this.getLeadCount(this.date_from,this.date_to, this.filter_designer);
    //this.myDesigners();
		this.loaderService.display(true);
	}

  ngAfterViewInit(){
    //this.getDesignerActionableCount(this.CMId, this.date_from, this.date_to)
  }

  getDesignerActionableCount(CMId, date_from, date_to){
    this.cmService.getCmDashboardDesignerActionables(CMId, date_from, date_to).subscribe(
      res => {
        this.usersCount['designer_data'] = res;
        this.loaderService.display(false);
      },
      err => {
        this.loaderService.display(false);
      }
    );
  }

  myDesigners(){
    this.loaderService.display(true);
    this.cmService.getDesignerList(this.CMId).subscribe(
      res => {
        this.my_designers = res.designer_list;
        this.loaderService.display(false);
      },
      err => {
        this.loaderService.display(false);
      }
    );
  }

	getLeadCount(date_fro,dat_to,filter_designer) {
    this.loaderService.display(true);
		this.cmService.getCmDashboardCount(this.CMId,date_fro,dat_to, filter_designer).subscribe(
			res => {
				this.usersCount = res;
        this.loaderService.display(false);
        this.getDesignerActionableCount(this.CMId, this.date_from, this.date_to)
			},
			err => {
        this.loaderService.display(false);
			}
		);
	}

  showDesignerStatusCountRow(status){
    var elem = document.getElementById('assigneDesignerStatusCountsRow');
    if(elem){
      if(status=='leads_assigned')  {
        elem.classList.remove('d-none');
      } else {
        elem.classList.add('d-none');
      }
    }
    
    
  }

  pre_10_percent;
  _10_50_percent;
  _50_percent;
  installation;
  showWip(index?){
    if(document.getElementById("wip-box").style.display == "none" || document.getElementById("wip-box").style.display == ""){
      //document.getElementById("wipbox-activator").style.border = "2px solid #3EC0F3";
      this.pre_10_percent = this.usersCount.designer_data[0].leads_assigned_pre_10_percent;
      this._10_50_percent=this.usersCount.designer_data[0].leads_assigned_10_50_percent;
      this._50_percent=this.usersCount.designer_data[0].leads_assigned_50_percent;
      this.installation=this.usersCount.designer_data[0].leads_assigned_installation;
      document.getElementById("wip-box").style.display = "block";
    }
    else{
      //document.getElementById("wipbox-activator").style.border = "0px";
      document.getElementById("wip-box").style.display = "none";
      this.pre_10_percent = undefined;
      this._10_50_percent=undefined;
      this._50_percent=undefined;
      this.installation=undefined;
    }
    
  }

  changeDateFrom(val){
    this.date_from = val;
    this.disable_to = false;
    // $(".to_date_container").css("display", "block");
  }

  changeDateTo(val){
    this.date_to = val; 
  }

  changeDesigner(val){
    this.filter_designer = val;
  }

  filterDashboard(){
    if(this.date_from || this.date_to){
      this.getLeadCount(this.date_from,this.date_to, this.filter_designer);
      // console.log("hello")
      // this.getDesignerActionableCount(this.CMId, this.date_from, this.date_to);
    }else{
      this.getLeadCount(false,false, this.filter_designer);
    }
  }

  downloadExcel(){
    this.cmService.exportLeads(this.date_from,this.date_to, this.role,this.CMId).subscribe(
      res =>{
      var contentType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
      var b64Data =  res._body;

      var blob = this.b64toBlob(b64Data, contentType,512);
      var blobUrl = URL.createObjectURL(blob);
      // let blob = new Blob(['\ufeff' + data._body], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      let dwldLink = document.createElement("a");
      // let url = URL.createObjectURL(blob);
      let isSafariBrowser = navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1;
      if (isSafariBrowser) {  //if Safari open in new window to save file with random filename.
      dwldLink.setAttribute("target", "_blank");
      }
      dwldLink.setAttribute("href", blobUrl);
      dwldLink.setAttribute("download", "lead.xlsx");
      dwldLink.style.visibility = "hidden";
      document.body.appendChild(dwldLink);
      dwldLink.click();
      document.body.removeChild(dwldLink);
      },
      err => {
        console.log(err);
      // this.erroralert = true;
      //   this.errorMessage = <any>JSON.parse(err['_body']).message;
      //   setTimeout(function() {
      //     this.erroralert = false;
      //    }.bind(this), 2000);
      }
    );
  }
  b64toBlob(b64Data, contentType, sliceSize) {
    contentType = contentType || '';
    sliceSize = sliceSize || 512;

    var byteCharacters = atob(b64Data);
    var byteArrays = [];

    for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      var slice = byteCharacters.slice(offset, offset + sliceSize);

      var byteNumbers = new Array(slice.length);
      for (var i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
      }

      var byteArray = new Uint8Array(byteNumbers);

      byteArrays.push(byteArray);
    }

    var blob = new Blob(byteArrays, {type: contentType});
    return blob;
  }

  showWipList(){
    if(document.getElementById("wip-box").style.display == "none" || document.getElementById("wip-box").style.display == ""){
      document.getElementById("wipbox-activator").style.border = "2px solid #3EC0F3";
      document.getElementById("wip-box").style.display = "block";
    }
    else{
      document.getElementById("wipbox-activator").style.border = "0px";
      document.getElementById("wip-box").style.display = "none";
    }
  }

}



// WEBPACK FOOTER //
// /Users/shobhit/Documents/codes/arrivae-frontend/src/app/platform/organisation/cm-dashboard/cm-dashboard.component.ts